import { Fragment } from "react";
import { observer } from 'mobx-react'
import { makeStyles, Theme, createStyles, Typography, Avatar, Divider, Button } from "@material-ui/core";
import { CableData } from "mdi-material-ui";
import { getSearchLink } from "../../Navigation/Links";
import { useNavigateInternally } from "../../Navigation/Hooks";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        prompt: {
            marginBottom: theme.spacing(1),
            maxWidth: 800,
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        avatar: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            width: '75px',
            height: '75px',
            margin: '16px auto'
        },
        divider: {
            width: '90%',
            margin: '30px auto',
        },
        title: {
            maxWidth: 700,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: theme.spacing(2),
        },
    })
);

interface InvalidEmailApologyProps {
    organizationName: string;
}

const InvalidEmailApology = observer((props: InvalidEmailApologyProps) => {

    /********* React hooks *********/

    const classes = useStyles();
    const navigate = useNavigateInternally();

    /********* Event handler *********/

    const onButtonClicked = () => {
        navigate(getSearchLink());
    }

    /********* Render *********/

    return (
        <Fragment>
            <Avatar className={classes.avatar}>
                <CableData fontSize='large' />
            </Avatar>
            <Typography variant="h4" className={classes.prompt}>
                Oops! We must have gotten our wires crossed.
            </Typography>
            <Typography>
                Sorry about that! We'll update our records and let {props.organizationName} know to update theirs as well.
            </Typography>
            <Divider className={classes.divider} />
            <Typography variant="h5" className={classes.title}>
                Interested in volunteering anyway?
            </Typography>
            <Button
                variant="contained"
                color='primary'
                onClick={onButtonClicked}
            >
                Browse Opportunities
            </Button>
        </Fragment>
    );
});

export default InvalidEmailApology;